import builder from '../builder';
import PictureStackLandscape from '../../streamline-icons/light/picture-stack-landscape.svg';

export default builder('IconPictureStackLandscapeLight', PictureStackLandscape);
